import Vue from 'vue'
import GlobalMixin from './mixin/global'

Vue.mixin(GlobalMixin)
